/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";

import publishing from "../../assets/icons/R4_Publishing.svg";
import Integration from "../../assets/icons/Portals_Integration.svg";
import Analysis from "../../assets/icons/Audit&Gap_Analysis.svg";
import Filings from "../../assets/icons/Brexit_Filings.svg";
import Support from "../../assets/icons/Application_Support.svg";
import Registration from "../../assets/icons/Import&Registration.svg";
import Leaflets from "../../assets/icons/Patient_Information.svg";
import Carousel from "../Carousel";

const allServices = [
  { Image: publishing, title: "SPL R4 Publishing", description: "We proactively monitor evolving regulatory landscapes to ensure compliance and strategic readiness." },
  { Image: Integration, title: "Submission Portals Integration", description: "While submission planning and tracking were mentioned, integration and management of country-specific submission portals (e.g., CESP, ESG, Swissmedic Gateway) is a distinct operational capability worth listing." },
  { Image: Analysis, title: "Dossier Audit & Gap Analysis", description: "A proactive service offering that involves reviewing existing dossiers for regulatory gaps and compliance risks. This adds value to lifecycle and submission readiness." },
  { Image: Filings, title: "Brexit Filings", description: "Regulatory filings specific to post-Brexit UK MHRA requirements are unique and were not previously mentioned." },
  { Image: Leaflets, title: "User Testing of Patient Information Leaflets (PIL)", description: "A specialized EU requirement for readability and comprehension testing of PiLs, not covered in earlier training or regulatory support sections." },
  { Image: Support, title: "Orphan Drug Application Support", description: "Regulatory strategy and submission support for orphan drug designation, particularly relevant for EU and US markets." },
  { Image: Registration, title: "Cosmetics Import & Registration (India)", description: "Regulatory filing and approval support for cosmetics under CDSCO, distinct from drug and medical device submissions." },
];

const RegulatoryServiceCard = ({ service }:{ service:any }) => (
  <div className="bg-white rounded-xl p-6 min-h-[260px] flex flex-col gap-3 h-full">
    <div className="flex justify-between items-start">
      <h3 className="font-bold text-lg w-3/4">{service.title}</h3>
      <img src={service.Image} alt="" className="w-12 h-12 object-contain" />
    </div>
    <p className="text-sm text-[#05326D] leading-relaxed">{service.description}</p>
  </div>
);

const RegulatoryCarousel: React.FC = () => {
  const serviceCards = allServices.map((service, index) => (
    <RegulatoryServiceCard key={index} service={service} />
  ));

  return (
    <Carousel
      title="Global Regulatory Service Portfolio"
      subtitle="Comprehensive, compliant, and customized regulatory solutions across global markets. From strategy to submission, we deliver precision, speed, and quality—worldwide."
      itemsPerPageConfig={{
        mobile: 1,
        tablet: 2,
        desktop: 3,
        large: 4
      }}
      backgroundColor="bg-[#F7FAFC]"
      showArrows={true}
      showDots={true}
      gap="gap-6"
      className="py-16"
      arrowPosition="outside"
      titleColor="text-[#05326D]"
      accentColor="border-[#B5AB28]"
      dotActiveColor="bg-[#003366]"
      dotInactiveColor="bg-gray-300"
    >
      {serviceCards}
    </Carousel>
  );
};

export default RegulatoryCarousel;
